import type { Quote } from '~/types/models';

type QuoteLifecycleFields = Pick<
    Quote,
    'status' | 'clientFacing' | 'publicSharedAt' | 'acceptanceSource'
>;

export function resolveQuoteAcceptanceSource(
    quote: QuoteLifecycleFields,
): NonNullable<Quote['acceptanceSource']> | null {
    if (quote.status !== 'accepted') return null;
    if (quote.acceptanceSource) return quote.acceptanceSource;

    // Legacy client approvals did not record provenance. A shared timestamp is
    // the durable evidence that the accepted document had left the workspace.
    if (quote.clientFacing !== false || quote.publicSharedAt) return 'client';

    return 'internal';
}

export function quoteWasSharedWithClient(quote: QuoteLifecycleFields): boolean {
    if (quote.status === 'draft') return false;
    if (quote.status === 'accepted') return resolveQuoteAcceptanceSource(quote) === 'client';
    return quote.clientFacing !== false;
}

export function quoteMatchesStatusGroup(
    quote: QuoteLifecycleFields,
    status: Quote['status'],
): boolean {
    if (status === 'sent') return quoteWasSharedWithClient(quote);
    return quote.status === status;
}
